var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.mainStyle },
    [
      _c(
        "div",
        { class: _vm.$style.kioskAuthHeader },
        [
          _c(
            "div",
            { class: _vm.$style.buttonWrapper },
            [
              _vm.showBackButton
                ? _c(
                    "BaseButton",
                    {
                      class: [_vm.$style.navBtn, _vm.$style.backBtn],
                      attrs: { "button-style": "Back" },
                      on: { click: _vm.back }
                    },
                    [
                      _c("svg", {
                        directives: [{ name: "svg", rawName: "v-svg" }],
                        class: _vm.$style.backIcon,
                        attrs: { symbol: "straight-arrow" }
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("Back")])
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("Logo"),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.$style.buttonWrapper },
            [
              _vm.showNextButton
                ? _c(
                    "BaseButton",
                    {
                      class: [_vm.$style.navBtn, _vm.$style.nextBtn],
                      attrs: {
                        disabled: _vm.nextDisabled,
                        "button-style": "Main"
                      },
                      on: { click: _vm.next }
                    },
                    [
                      _c("span", [_vm._v("Next")]),
                      _vm._v(" "),
                      _c("svg", {
                        directives: [{ name: "svg", rawName: "v-svg" }],
                        class: _vm.$style.nextIcon,
                        attrs: { symbol: "straight-arrow" }
                      })
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.$style.kioskAuthMain },
        [
          _vm.isNew
            ? _c("span", { class: _vm.$style.newLabel }, [_vm._v("New")])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { class: _vm.$style.kioskAuthTitle }, [
            _c("span", { class: _vm.$style.titleLine }),
            _vm._v(" "),
            _c("h2", [_vm._v(_vm._s(_vm.title))]),
            _vm._v(" "),
            _c("span", { class: _vm.$style.titleLine })
          ]),
          _vm._v(" "),
          _vm._t("default")
        ],
        2
      ),
      _vm._v(" "),
      _c("KioskTryBlock")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/layouts/KioskAuthLayout.vue?vue&type=template&id=e50be668&
// module id = null
// module chunks = 